import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from 'src/components/CommonModal';
import { MEASUREMENT } from 'src/constants/common';
import { formatLinearFootage } from 'src/utils/CommonFunctions';

import { IMismatchModal } from './quoteDetailModal.interface';

const WeightLinearFootageMismatchModal: FC<IMismatchModal> = ({ handleActionClose, handleMismatch, data }) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            title={<h6 className="text-textSecondary text-lg font-semibold">{t('QuotingHub.QuotingDashboard.Review_Confirm_Changes')}</h6>}
            modalTitleDesc={
                <>
                    <p className="text-grayLight600 text-sm font-normal">{t('QuotingHub.QuotingDashboard.Review_and_confirm_the_updated_quote_details')}</p>
                    <p className="text-grayLight600 text-sm font-normal">
                        {t('Common.Total_Weight')}:{' '}
                        <span className="font-semibold text-primary">{data?.totalWeight ? `${data?.totalWeight} ${data?.weightMeasurement === MEASUREMENT.WEIGHT1.value ? 'lbs' : 'kgs'}` : ''}</span> |{' '}
                        {t('Common.Linear_Footage')}: <span className="font-semibold text-primary">{data?.linearFootage ? `${formatLinearFootage(data?.linearFootage)} Ft.` : ''}</span>
                    </p>
                </>
            }
            modalHeaderClass="border-b-0"
            modalFooterClass="border-t-0"
            handleClose={handleActionClose(false)}
            size={'max-w-[420px]'}
            primaryBtnText={t('Common.Confirm')}
            secondaryBtnText={t('Common.Close')}
            secondaryBtnOnClick={handleActionClose(true)}
            primaryBtnOnClick={handleMismatch}
        >
            <></>
        </CommonModal>
    );
};

export default WeightLinearFootageMismatchModal;
